import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimZeroes',
  standalone: false,
})
export class TrimZeroesPipe implements PipeTransform {
  public transform(value: string) {
    let trimmed = value.trim();

    trimmed = trimmed.replace(/^0+/u, '');

    return trimmed === '' ? '0' : trimmed;
  }
}
